import React from 'react';

/**
 * Stroke icons on a 24px grid, drawn inline so they scale and recolour with
 * the surrounding text. No icon font, no emoji.
 */
const Svg = ({ size = 16, color = 'currentColor', width = 1.7, children }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={width}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const CalendarIcon = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="5" width="17" height="16" rx="2" />
    <path d="M3.5 10h17" />
    <path d="M8 3v4" />
    <path d="M16 3v4" />
  </Svg>
);

export const ChevronDownIcon = (p) => (
  <Svg {...p}>
    <path d="M7 10l5 5 5-5" />
  </Svg>
);

export const ChevronLeftIcon = (p) => (
  <Svg {...p}>
    <path d="M14 7l-5 5 5 5" />
  </Svg>
);

export const ChevronRightIcon = (p) => (
  <Svg {...p}>
    <path d="M10 7l5 5-5 5" />
  </Svg>
);

export const DownloadIcon = (p) => (
  <Svg {...p}>
    <path d="M12 3v12" />
    <path d="M7.5 10.5 12 15l4.5-4.5" />
    <path d="M4.5 18.5V20h15v-1.5" />
  </Svg>
);

export const PersonIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="3.6" />
    <path d="M5 20c0-3.4 3.1-5.4 7-5.4s7 2 7 5.4" />
  </Svg>
);

export const SearchIcon = (p) => (
  <Svg {...p}>
    <circle cx="10.5" cy="10.5" r="6.5" />
    <path d="M15.5 15.5 20 20" />
  </Svg>
);

export const PrinterIcon = (p) => (
  <Svg {...p}>
    <path d="M7 9V3h10v6" />
    <rect x="4.5" y="9" width="15" height="7" rx="1.5" />
    <path d="M7 16h10v5H7z" />
  </Svg>
);

export const PencilIcon = (p) => (
  <Svg {...p}>
    <path d="M16.5 4.5l3 3L9 18l-4 1 1-4z" />
  </Svg>
);

export const CrossIcon = (p) => (
  <Svg {...p}>
    <path d="M7.5 7.5l9 9" />
    <path d="M16.5 7.5l-9 9" />
  </Svg>
);

export const CheckIcon = (p) => (
  <Svg {...p}>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </Svg>
);

export const ClockIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8" />
    <path d="M12 8v4.4l2.8 1.8" />
  </Svg>
);

export const ReceiptIcon = (p) => (
  <Svg {...p}>
    <path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" />
    <path d="M9.5 8h5" />
    <path d="M9.5 12h5" />
  </Svg>
);

export const CloudOffIcon = (p) => (
  <Svg {...p}>
    <path d="M6.5 18a4 4 0 0 1-.4-8A5.6 5.6 0 0 1 17 9.4a3.6 3.6 0 0 1 .3 7.1" />
    <path d="M4 4l16 16" />
  </Svg>
);

export const AlertIcon = (p) => (
  <Svg {...p}>
    <path d="M12 7.5v6" />
    <path d="M12 16.6v.4" />
  </Svg>
);

export const InfoIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 11v5.5" />
    <path d="M12 7.8v.6" />
  </Svg>
);
